import { Colors } from 'src/components/theme'
import { SubscriptionInterval } from 'src/types/payments'

export const SUBSCRIPTION_MODAL_DIMENSIONS = {
  height: 700,
  width: 1100,
}
export const SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS = {
  width: 480,
}

// Our paid tiers in order of increasing features
export const SUBSCRIPTION_TIERS = ['free', 'entry', 'intermediate', 'full'] as const

export const SUBSCRIPTION_OCCURRENCE_OPTIONS: Array<{
  id: SubscriptionInterval
  label: string
  extra?: string
}> = [
  {
    id: 'month',
    label: 'Monthly',
    extra: undefined,
  },
  {
    id: 'year',
    label: 'Annually',
    extra: 'Save 15%',
  },
]

// Used for the subscription table rows
type TiersAccess = {
  [tier in (typeof SUBSCRIPTION_TIERS)[number]]: boolean
}

type TierSectionDetailsRow = {
  title: string
  link?: string
  access: TiersAccess
}

export type SubscriptionSection = {
  title: string
  subtitle: string
  color: string
  rows: TierSectionDetailsRow[]
}

export const SUBSCRIPTION_SECTIONS: SubscriptionSection[] = [
  // Functionality,
  {
    title: 'FUNCTIONALITY',
    subtitle:
      'Essential mapping features, customizable branding options, and report downloads for a seamless user experience.',
    color: Colors.blueDark,
    rows: [
      {
        title: 'Map Controls',
        link: undefined,
        access: {
          free: true,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Download Reports & Widgets',
        link: undefined,
        access: {
          free: true,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Create Lists & Save Locations',
        link: undefined,
        access: {
          free: true,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Branding',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Custom Geo-Fencing',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: false,
          full: true,
        },
      },
    ],
  },
  // Reports
  {
    title: 'REPORTS',
    subtitle:
      'Comprehensive reports offering rich insights on demographics, ownership, and more to inform your strategic decisions.',
    color: Colors.tealDark,
    rows: [
      {
        title: 'Demographics',
        link: undefined,
        access: {
          free: true,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Radius Ring Trade Area',
        link: undefined,
        access: {
          free: true,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Drive Time Trade Area',
        link: undefined,
        access: {
          free: true,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Car Traffic',
        link: undefined,
        access: {
          free: false,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Property Records',
        link: undefined,
        access: {
          free: false,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'True Trade Area',
        link: undefined,
        access: {
          free: false,
          entry: true,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Zoning',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Location Visits',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Rank',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Ownership',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: true,
          full: true,
        },
      },
      {
        title: 'Shopping Center Overview',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: false,
          full: true,
        },
      },
    ],
  },

  // Tools
  {
    title: 'TOOLS',
    subtitle:
      'Advanced tools that provide specialized, in-depth analysis, and enhanced project management capabilities.',
    color: Colors.orangeDark,
    rows: [
      {
        title: 'Tenant Finder',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: false,
          full: true,
        },
      },
      {
        title: 'Map Builder',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: false,
          full: true,
        },
      },
      {
        title: 'Owner Reveal',
        link: undefined,
        access: {
          free: false,
          entry: false,
          intermediate: false,
          full: true,
        },
      },
    ],
  },
]
